export const COLLAPSIBLE_CLASS = 'nav-sidebar-collapsible';
export const COLLAPSIBLE_CHEVRON_WRAPPER_CLASS = 'nav-sidebar-collapsible-chevron-wrapper';
export const COLLAPSIBLE_TITLE_WRAPPER_CLASS = 'nav-sidebar-collapsible-title-wrapper';
export const COLLAPSIBLE_CONTENT_CLASS = 'nav-sidebar-collapsible-content';
